<template>
	<div class="box">
		<div class="communication" v-show="!zsgltdBool">
			<div class="fl Atlist retrieval">
				<div class="commtitle">
					<i class="c1 iconImg"></i>诊所管理<span style="color:#4B4B4B ; font-weight: 600;">-诊所管理</span>
				</div>
				<div class="retrievalipt">
					<el-input placeholder="诊所名字、诊所编号或管理者姓名" prefix-icon="el-icon-search" v-model="input21">
					</el-input>
				</div>
				<div class="dqBox" v-if="false">
					<p>地区</p>
					<div class="selectDiv dq fl">
						<div class="fl">
							<p class="">省/直辖市</p>
							<el-select v-model="shengId" clearable placeholder="请选择" @change="jsshiFn">
								<el-option v-for="(item,index) in jssList" :key="index" :label="item.cName" :value="item.id">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="selectDiv1 dq fl">
						<div class="fl">
							<p>市</p>
							<el-select v-model="shiId" clearable placeholder="请选择" @change="jsxianFn">
								<el-option v-for="(item,index) in jsshiList" :key="index" :label="item.cName" :value="item.id">
								</el-option>
							</el-select>
						</div>
					</div>
					<!--<div class="selectDiv dq fl">
			 			<div class="fl">
			 				<p>区/县</p>
				 			<el-select v-model="xianId" placeholder="请选择">
							    <el-option
							      v-for="(item,index) in jsxianList"
							      :key="index"
							      :label="item.cName"
							      :value="item.id">
							    </el-option>
							</el-select>
			 			</div>
			 		</div>-->
				</div>
				<div class="dqBox" v-if="false">
					<p>时间</p>
					<div class="blockDiv fl">
						<div class="fl">
							<el-date-picker v-model="value1" type="datetimerange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd-HH-mm-ss">
							</el-date-picker>
						</div>
					</div>
				</div>
				<div class="gjjiansuo">
					<span @click="daysflagqbs" :class="{'active':daysflag==''}">全部</span>
					<span @click="daysflagdays" :class="{'active':daysflag==1}">今日</span>
					<span @click="daysflagweekdays" :class="{'active':daysflag==7}">近七天</span>
					<span @click="daysflagmonths" :class="{'active':daysflag==30}">近一月</span>
					<span @click="daysflagyears" :class="{'active':daysflag==365}">近一年</span>
				</div>
				<div class="dqBox">
					<div class="boxbtn">
						<button @click="jiansuoFn" :disabled="sousuo">
							搜索
						</button>
					</div>
				</div>
			</div>
			<div class=" Attable">
				<div class="tablehzlist">
					<ul class="tableHeader">
						<li v-for="item in tableList">{{item.tableName}}</li>
					</ul>
					<!-- -->
					<div class="tabletd" @scroll="scrollEvent($event)">
						<ul class="tablecontent tableHeader" v-for="item in datalist">
							<li>
								<p>{{item.cName}}</p>
							</li>
							<li>{{item.cNo}}</li>
							<li>否</li>
							<li>
								<p>{{arrFn(item.cFullName)}}</p>
							</li>
							<li>{{item.cPerson}}</li>
							<li>
								<div>
									<button @click="company_rowFn(item.id)">诊所管理</button>
								</div>
								<div>
									<button @click="company_deletesFn(item.id)">删除诊所</button>
								</div>
							</li>
							<li>
							</li>
						</ul>
						<div class="list-more" v-show="deviceTip">
							<p>{{deviceTip}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="communicationPt" v-if="zsgltdBool">
			<div class="joinedComposition">
				<div class="header">
					<div class="fl">
						<i class="el-icon-arrow-left" @click="fanhuiFn()"></i>
						<span></span>
						<span>{{companysrow.cNo}}</span>
					</div>
					<div v-show="mzglBool">
						<!--<div></div>-->
						<div>
							<ul class="tableList" v-show="!xxgsVal">
								<li>编号</li>
								<li>地区</li>
								<li>详细地址</li>
								<li>联系电话</li>
								<li>认证材料</li>
								<li>官方网站</li>
								<li>公众号</li>
								<li>修改诊所信息</li>
							</ul>

						</div>
					</div>
				</div>
				<div class="content">
					<div class="fl">
						<div class="navMenuTd active" @click="tabClick('1',$event)">
							<span>门诊管理</span>
							<i class="el-icon-arrow-right"></i>
						</div>
						<div class="navMenuTd" @click="tabClick('2',$event)">
							<span>成员管理</span>
							<i class="el-icon-arrow-right"></i>
						</div>
					</div>
					<div class="">
						<div class="modelcontent" v-show="!xxgsVal">
							<div v-show="mzglBool">
								<div class="">
									<ul class="tablelist">
										<li>{{companysrow.cNo}}</li>
										<li>
											<p>{{arrFn(companysrow.cFullName)}}</p>
										</li>
										<li>
											<p>
												{{companysrow.cAddr}}
											</p>
										</li>
										<li>{{companysrow.cTel}}</li>
										<li>
											<p @click="yyxkImgFn"><i class="el-icon-search"></i>营业许可证</p>
											<p @click="yyzzImgFn"><i class="el-icon-search"></i>营业执照</p>
											<div class="dialogImg" v-show="yyxkImg||yyzzImg">
												<i class="el-icon-close" @click="imgCloseFn()"></i>
												<img :src="companysrow.cImgA" alt="" v-show="yyxkImg" />
												<img :src="companysrow.cImgB" alt="" v-show="yyzzImg" />
											</div>
										</li>
										<li>
											<p>
												{{companysrow.cUrl}}
											</p>
										</li>
										<li>
											<p>
												{{companysrow.cWxImg}}
											</p>
										</li>
										<li>
											<div>
												<button @click="xxgsVal=true">修改信息</button>
											</div>
										</li>
									</ul>
								</div>
							</div>
							<div v-show="cyglBool">
								<div class="userSet">
									<div>
										<div class="fl">
											<div class="fl">
												<button @click="addCyBool=true">添加人员</button>
											</div>
											<div class="fl">
												<button @click="usersetBool=true">设置</button>
											</div>
										</div>
										<div class="fr" v-show="usersetBool">
											<!--usersetBool-->
											<div>
												<button @click="successFn">确定</button>
											</div>
											<div>
												<button @click="usersetBool=false" style="background: #B0B0B0; ">关闭</button>
											</div>
										</div>
									</div>
								</div>
								<div class="tdlist">
									<div>
										<div class="zl">
											<p>院&nbsp;&nbsp;长</p>
										</div>
										<div class="" style="overflow: auto;">
											<div class="tdcyBox" v-for="item in tdlist" v-if="item.uLoginID==companysrow.cLoginID||item.uTypeID==1||item.uIsTwo==1||item.uIsTwo==2||item.uIsTwo==3">
												<div>
													<div>
														<img v-if="!item.uImg=='http://api.bats-bio.com'||!item.uImg==''" :src="'http://api.bats-bio.com'+item.uImg" alt="" />
														<img v-if="item.uImg=='http://api.bats-bio.com'||item.uImg==''&&item.uTypeID==8" src="../../../assets/image/DI.png" alt="" />
														<img v-if="item.uImg=='http://api.bats-bio.com'||item.uImg==''&&item.uTypeID==0" src="../../../assets/image/DI.png" alt="" />
														<img v-if="item.uImg=='http://api.bats-bio.com'||item.uImg==''&&item.uTypeID==1" src="../../../assets/image/DI.png" alt="" />
														<img v-if="item.uImg=='http://api.bats-bio.com'||item.uImg==''&&item.uTypeID==2" src="../../../assets/image/DR.png" alt="" />
														<img v-if="item.uImg=='http://api.bats-bio.com'||item.uImg==''&&item.uTypeID==3" src="../../../assets/image/AT.png" alt="" />
													</div>
													<div>
														<p>{{item.uName==""?item.uTel:item.uName}}</p>
														<p class=""  @click="checkActiveFn($event,item.uTel,item.id)" >
															<!--checkActiveFn($event)-->
															<i class="check"  :class="[item.uTypeID==1||item.uIsTwo==1||item.uLoginID==companysrow.cLoginID?'active':'']"></i>
															院长
														</p>
														<span v-show="item.uTypeID==1">院长</span>
														<span v-show="item.uTypeID==2">医生</span>
														<span v-show="item.uTypeID==3">助理</span>
														<i class="el-icon-refresh-right" title="撤回"  v-show="usersetBool" @click="remoreArr(item.id,$event)"></i>
														<i class="el-icon-delete-solid" title="删除"  v-show="usersetBool" @click="adddeleArr(item.id,$event)"></i>
														<div class="dpcPdm">
															<p v-show="usersetBool" @click="checkActiveFnDpc($event,item.uTel,item.id)">
																<!--checkActiveFn($event)-->
																<i class="check" :class="[item.uIsAccDpc==1?'active':'']"></i> DPC
															</p>
															<p v-show="usersetBool" @click="checkActiveFnPdm($event,item.uTel,item.id)">
																<!--checkActiveFn($event)-->
																<i class="check" :class="[item.uIsAccPdm==1?'active':'']"></i> PDM
															</p>
															<p v-show="usersetBool" @click="checkActiveFnCep($event,item.uTel,item.id)">
																<!--checkActiveFn($event)-->
																<i class="check" :class="[item.uIsAccCep==1?'active':'']"></i> CEP
															</p>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div>
										<div class="zl">
											<p>医&nbsp;&nbsp;生</p>
										</div>
										<div class="" style="overflow: auto;">
											<div class="tdcyBox" v-for="item in tdlist" v-if="item.uTypeID==2&&item.uIsTwo==0&&item.uLoginID!=companysrow.cLoginID">
												<div>
													<div>
														<img v-if="!item.uImg=='http://api.bats-bio.com'||!item.uImg==''" :src="'http://api.bats-bio.com'+item.uImg" alt="" />
														<img v-if="item.uImg=='http://api.bats-bio.com'||item.uImg==''&&item.uTypeID==1" src="../../../assets/image/DI.png" alt="" />
														<img v-if="item.uImg=='http://api.bats-bio.com'||item.uImg==''&&item.uTypeID==2" src="../../../assets/image/DR.png" alt="" />
														<img v-if="item.uImg=='http://api.bats-bio.com'||item.uImg==''&&item.uTypeID==3" src="../../../assets/image/AT.png" alt="" />
													</div>
													<div>
														<p>{{item.uName==""?item.uTel:item.uName}}</p>
														<p class="" v-show="usersetBool" @click="checkActiveFn($event,item.uTel,item.id)" >
															<!--checkActiveFn($event)-->
															<i class="check"  :class="[item.uTypeID==1||item.uIsTwo==1||item.uLoginID==companysrow.cLoginID?'active':'']"></i>
															院长
														</p>
														<span v-show="item.uTypeID==1">院长</span>
														<span v-show="item.uTypeID==2">医生</span>
														<span v-show="item.uTypeID==3">助理</span
														<i class="el-icon-refresh-right" title="撤回"  v-show="usersetBool" @click="remoreArr(item.id,$event)"></i>
														<i class="el-icon-delete-solid" title="删除"  v-show="usersetBool" @click="adddeleArr(item.id,$event)"></i>
														<div class="dpcPdm">
															<p v-show="usersetBool" @click="checkActiveFnDpc($event,item.uTel,item.id)">
																<!--checkActiveFn($event)-->
																<i class="check" :class="[item.uIsAccDpc==1?'active':'']"></i> DPC
															</p>
															<p v-show="usersetBool" @click="checkActiveFnPdm($event,item.uTel,item.id)">
																<!--checkActiveFn($event)-->
																<i class="check" :class="[item.uIsAccPdm==1?'active':'']"></i> PDM
															</p>
															<p v-show="usersetBool" @click="checkActiveFnCep($event,item.uTel,item.id)">
																<!--checkActiveFn($event)-->
																<i class="check" :class="[item.uIsAccCep==1?'active':'']"></i> CEP
															</p>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div>
										<div class="zl">
											<p>助&nbsp;&nbsp;理</p>
										</div>
										<div class="" style="overflow: auto;">
											<div class="tdcyBox" v-for="item in tdlist" v-if="item.uTypeID==3&&item.uIsTwo==0&&item.uLoginID!=companysrow.cLoginID">
												<div>
													<div>
														<img v-if="!item.uImg=='http://api.bats-bio.com'||!item.uImg==''" :src="'http://api.bats-bio.com'+item.uImg" alt="" />
														<img v-if="item.uImg=='http://api.bats-bio.com'||item.uImg==''&&item.uTypeID==1" src="../../../assets/image/DI.png" alt="" />
														<img v-if="item.uImg=='http://api.bats-bio.com'||item.uImg==''&&item.uTypeID==2" src="../../../assets/image/DR.png" alt="" />
														<img v-if="item.uImg=='http://api.bats-bio.com'||item.uImg==''&&item.uTypeID==3" src="../../../assets/image/AT.png" alt="" />
													</div>
													<div>
														<p>{{item.uName}}</p>
														<p class="" v-show="usersetBool" @click="checkActiveFn($event,item.uTel,item.id)" >
															<!--checkActiveFn($event)-->
															<i class="check"  :class="[item.uTypeID==1||item.uIsTwo==1||item.uLoginID==companysrow.cLoginID?'active':'']"></i>
															院长
														</p>
														<span v-show="item.uTypeID==1">院长</span>
														<span v-show="item.uTypeID==2">医生</span>
														<span v-show="item.uTypeID==3">助理</span>
														<i class="el-icon-refresh-right" title="撤回"  v-show="usersetBool" @click="remoreArr(item.id,$event)"></i>
														<i class="el-icon-delete-solid" title="删除"  v-show="usersetBool" @click="adddeleArr(item.id,$event)"></i>
														<div class="dpcPdm">
															<p v-show="usersetBool" @click="checkActiveFnDpc($event,item.uTel,item.id)">
																<!--checkActiveFn($event)-->
																<i class="check" :class="[item.uIsAccDpc==1?'active':'']"></i> DPC
															</p>
															<p v-show="usersetBool" @click="checkActiveFnPdm($event,item.uTel,item.id)">
																<!--checkActiveFn($event)-->
																<i class="check" :class="[item.uIsAccPdm==1?'active':'']"></i> PDM
															</p>
															<p v-show="usersetBool" @click="checkActiveFnCep($event,item.uTel,item.id)">
																<!--checkActiveFn($event)-->
																<i class="check" :class="[item.uIsAccCep==1?'active':'']"></i> CEP
															</p>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="zsxxFrom" v-if="xxgsVal">
							<!--v-show="xxgsVal"-->
							<div>
								<span>诊所信息</span>
								<div>
									<button @click="xxgsVal=false">
										返回
									</button>
								</div>
								<div>
									<button @click="xgxxFn()">
										修改确认
									</button>
								</div>
							</div>
							<div>
								<div class="fromIpt">
									<div>
										<div class="comClass">
											<p>
												<i></i> 诊所名称 (必填)
											</p>
											<div>
												<el-input v-model="nameVal" placeholder="请输入内容"></el-input>
											</div>
										</div>
										<div class="comClass">
											<p>
												<i></i> 诊所简称 (最多可输入4个字) (必填)
											</p>
											<div>
												<el-input v-model="minname" maxlength="4" placeholder="请输入内容"></el-input>
											</div>
										</div>
										<!--<div class="comClass">
											<p>
												<i></i> 设置诊所登录密码
											</p>
											<div>
												<el-input v-model="zspwdVal" placeholder="请输入内容" disabled></el-input>
											</div>
										</div>-->
										<div class="comClass1">
											<p>
												<i></i> 地区 (必填)
											</p>
											<div style="overflow: hidden;">
												<div class="selectDiv fl">
													<div class="fl">
														<el-select v-model="sheng" placeholder="" @change="shiFn">
															<el-option v-for="(item,index) in sList" :key="index" :label="item.cName" :value="item.id">
															</el-option>
														</el-select>
													</div>
													<span class="fl">
														<p>省/</p>
														<p>直辖市</p>
													</span>
												</div>
												<div class="selectDiv1 fl">
													<div class="fl">
														<el-select v-model="shi" placeholder="" @change="xianFn">
															<el-option v-for="(item,index)  in shiList" :key="index" :label="item.cName" :value="item.id">
															</el-option>
														</el-select>
													</div>
													<span class="fl">
														<p>市</p>
													</span>
												</div>
												<!--<div class="selectDiv fl">
										 			<div class="fl">
											 			<el-select v-model="xian" placeholder="">
														    <el-option
														      v-for="(item,index) in xianList"
														      :key="index"
														      :label="item.cName"
														      :value="item.id">
														    </el-option>
														</el-select>
										 			</div>
													<span class="fl">
														<p>区/县</p>
													</span>
										 		</div>-->
											</div>
										</div>
										<div class="comClass">
											<p>
												<i></i> 详细地址(必填)
											</p>
											<div>
												<el-input v-model="addressVal" placeholder="请输入内容"></el-input>
											</div>
										</div>
										<div class="comClass">
											<p>
												<i></i> 联系电话 (必填)
											</p>
											<div>
												<el-input v-model="lxtel" placeholder="请输入内容"></el-input>
											</div>
										</div>
									</div>
								</div>
								<div class="fromIpt1">
									<div>
										<div class="comClass">
											<p>
												<i></i> 官方网站 (选填)
											</p>
											<div>
												<el-input v-model="gfwzVal" placeholder="请输入内容"></el-input>
											</div>
										</div>
										<div class="comClass">
											<p>
												<i></i> 公众号 (选填)
											</p>
											<div>
												<el-input v-model="vxVal" placeholder="请输入内容"></el-input>
											</div>
										</div>
										<div class="comClass2">
											<p>
												<i></i> 认证材料 (必填)
											</p>
											<div>
												<div class="fl">
													<el-upload class="avatar-uploader" action="https://api.bats-bio.com/ajax/" accept=".png,.jpg" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
														<img v-if="ylImg" :src="ylImg" class="avatar">
														<i v-else class="el-icon-picture"></i>
													</el-upload>
													<span>医疗诊所执业许可</span>
												</div>
												<div class="fl">
													<el-upload class="avatar-uploader" action="https://api.bats-bio.com/ajax/" accept=".png,.jpg" :show-file-list="false" :on-success="handleAvatarSuccess1" :before-upload="beforeAvatarUpload">
														<img v-if="yyImg" :src="yyImg" class="avatar">
														<i v-else class="el-icon-picture"></i>
													</el-upload>
													<span>营业执照</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>
			<div class="dialogAddopple" v-if="addCyBool">
				<div>
					<div class="addHeader">
						<p><i class="el-icon-close fr" @click="addCyBool=false"></i></p>
						<p>邀请成员</p>
					</div>
					<div class="addCenter">
						<p>请您输入邀请成员的手机号</p>
						<div>
							<input type="text" name="" id="" value="" v-model="tel" />
						</div>
					</div>
					<div class="addFooter">
						<div>
							<button @click="yqgrFn">发出邀请</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog
		  title=""
		  :visible.sync="centerDialogVisible"
		  width="80%"
		  center>
		  <img style="text-align: center;" :src="DialogImg"/>
		  <span slot="footer" class="dialog-footer">
		    <!--<el-button @click="centerDialogVisible = false">取 消</el-button>-->
		    <el-button type="primary" @click="centerDialogVisible = false">关 闭</el-button>
		  </span>
		</el-dialog>
	</div>
</template>

<script>
	import { set_dual_status_new,company_list, company_row,company_deletes, users_list_company,user_save, get_company, city_ztree, company_save, imgbase64upload, delete_from_company, set_dual_status } from '../../http/api.js'
	export default {
		components: {
			//		communicationptcom
		},
		data() {
			return {
				jsbq: ["种植修复", "嵌体修复", "隐适美", "全口义齿", "深覆颌", "对刃"],
				tableData: null,
				ddBool: true,
				ddBool1: true,
				tableList: [{
					tableName: '诊所名称',
				}, {
					tableName: '诊所编号',
				}, {
					tableName: '是否连锁',
				}, {
					tableName: '地区',
				}, {
					tableName: '管理者',
				}, {
					tableName: '操作',
				}],
				jggtable: false,
				input21: '',
				radio: '',
				value: '',
				options: [{
					lable: '1',
					value: '1'
				}],
				imageUrl: '',
				hznumBool: false,
				lrhzXxBool: false,
				DIYbqBool: false,
				datalist: [],
				devicePageSize: 10, //每页显示
				devicePageNum: 1, //当前页
				devicePageTotal: 0, //总条数
				devicePageTotalPages: 0, //总页数
				deviceListIsFinish: false, //是否加载完成
				deviceListIsLoad: false, //是否加载更多
				deviceListnodata: false, //是否有数据
				deviceTip: '',
				deviceList: [],
				deviceRow: {},
				ageMin: '',
				ageMax: '',
				yearList: [],
				yearVal: '',
				monthVal: '',
				sclyArr: [],
				yyxkImg: false,
				yyzzImg: false,
				mzglBool: true,
				cyglBool: false,
				xxgsVal: false,
				zsgltdBool: false,
				glList: [],
				drList: [],
				atList: [],
				addCyBool: false,
				tdlist: [],
				tel: '',
				xxgsVal: false,
				nameVal: '',
				zspwdVal: '1234abcd',
				addressVal: '',
				lxtel: '',
				gfwzVal: '',
				vxVal: '',
				ylImg: '',
				yyImg: '',
				sList: [],
				sheng: '',
				shiList: [],
				shi: '',
				xianList: [],
				xian: '',
				shengId: '',
				shiId: '',
				xianId: '',
				jssList: [],
				jsshiList: [],
				jsxianList: [],
				companysrow: {},
				yyzzImg: '',
				yyxkImg: '',
				usersetBool: false,
				minname: '',
				dateList: [{
					dateName: '今日',
					index: '1'
				}, {
					dateName: '三日内',
					index: '2'
				}, {
					dateName: '一周内',
					index: '3'
				}, {
					dateName: '一月内',
					index: '4'
				}, {
					dateName: '三月内',
					index: '5'
				}, {
					dateName: '一年内',
					index: '6'
				}],
				dateIndex: '',
				shengId: '',
				shiId: '',
				xianId: '',
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}],
				},
				value1: '',
				deleUser: [],
				sousuo: false,
				centerDialogVisible:false,
				DialogImg:'',
				daysflag:''
			}
		},
		beforeMount() {
			this.getlist();
			this.yearFn();
			this.chengshiFn();
			this.jschengshiFn();
		},
		methods: {
			daysflagqbs(){
  				if(this.daysflag==''){
  					this.daysflag='';
  					this.jiansuoFn();
  					
  				}else{
  					this.daysflag='';
  					this.keyName='';
  					this.jiansuoFn();
  				}
  			},
  			daysflagdays(){
  				if(this.daysflag==1){
  					this.daysflag='';
  					this.jiansuoFn();
  					
  				}else{
  					this.daysflag=1;
  					this.keyName='';
  					this.jiansuoFn();
  				}
  			},
  			daysflagweekdays(){
  				if(this.daysflag==7){
  					this.daysflag='';
  					this.jiansuoFn();
  				}else{
  					this.daysflag=7;
  					this.keyName='';
  					this.jiansuoFn();
  				}
  			},
  			daysflagmonths(){
  				if(this.daysflag==30){
  					this.daysflag='';
  					this.jiansuoFn();
  				}else{
  					this.daysflag=30;
  					this.keyName='';
  					this.jiansuoFn();
  				}
  			},
  			daysflagyears(){
  				if(this.daysflag==365){
  					this.daysflag='';
  					this.jiansuoFn();
  				}else{
  					this.daysflag=365;
  					this.keyName='';
  					this.jiansuoFn();
  				}
  			},
  			company_deletesFn(id){
  				this.$confirm('您确定要删除此诊所, 是否继续?', '提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消',
		          type: 'warning'
		        }).then(() => {
		          var data = {
		          	ids:id
		          }
		          company_deletes(data).then(res=>{
		          	this.$message({
		                message:'删除成功',
		                type: 'success',
		                duration:1000,
		                onClose:()=>{
		                	this.jiansuoFn();
		         		}
					})
		          })
		        }).catch(() => {
		                   
		        });
  			},
			yearFn() {
				for(var i = 1910; i <= new Date().getFullYear(); i++) {
					//					addOption(birth_year, i, i - 1909);
					var data = {
						age: i
					}
					this.yearList.unshift(data);
				}
			},
			arrFn(str) {
				var arr = []
				arr = (str || "").split(',');
				return arr[1] + '/' + arr[2]
			},
			adddeleArr(id, event) {
				this.deleUser.push(id);
				var el = event.currentTarget;
				$(el).hide();
				$(el).siblings('.el-icon-refresh-right').show();
				console.log(this.deleUser)
			},
			remoreArr(id, event) {
				for(var i = 0; i < this.deleUser.length; i++) {
					if(this.deleUser[i] == id) {
						this.deleUser.splice(1, 1);
						var el = event.currentTarget;
						$(el).hide();
						$(el).siblings('.el-icon-delete-solid').show();
					}
				}
			},
			successFn() {
				this.$confirm('您确认要保存您所操纵的成员权限？', '确认信息', {
						distinguishCancelAndClose: true,
						confirmButtonText: '确定',
						cancelButtonText: '放弃'
					})
					.then(() => {
						this.$message({
							type: 'success',
							message: '保存成功',
							duration: 1000,
							onClose: () => {
								for(var i = 0; i < this.deleUser.length; i++) {
									this.deleteFn(this.deleUser[i])
								}
								this.company_rowFn(this.companysrow.id)
							}
						});
					})
					.catch(action => {

					});
			},
			errorFn() {
				this.deleteFn = [];
			},
			deleteFn(id) {
				var data = {
					cpy_id: this.companysrow.id,
					uid: id
				}
				delete_from_company(data).then(res => {
					//					console.log(res.data)
				})
			},
			getlist() {
				let data = {
					page: this.devicePageNum,
					limit: this.devicePageSize,
					rz: 1,
					keyName: this.input21,
					province_id: this.shengId,
					city_id: this.shiId,
					day:this.daysflag,
				}
				company_list(data).then(res => {
					if(res.result == 0) {
						this.devicePageTotal = res.total;
						//需要加当前页和每页显示
						//			        this.devicePageSize = res.pageSize;

						//			        this.devicePageNum = res.pageNum;
						this.devicePageTotalPages = res.count;
						if(res.data == '') {
							this.deviceListnodata = true;
							this.deviceListIsLoad = false;
							this.deviceListIsFinish = true;
							this.devicePageNum = 1;
							this.deviceTip = "暂无数据";
							return false;
						} else {
							if(this.devicePageTotalPages < this.devicePageSize) {
								this.deviceListnodata = true;
								this.deviceListIsLoad = false;
								this.deviceListIsFinish = true;
								this.devicePageNum = 1;
								this.deviceTip = "暂无数据";
								//					            return false;  	
							} else {
								this.deviceListIsLoad = true;
								this.deviceListIsFinish = false;
								this.devicePageNum++;
								this.deviceTip = "正在加载中~";
							}
						}
						this.datalist = this.datalist.concat(res.data);
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
							duration: 1000,
							onClose: () => {}
						})
						this.deviceListIsLoad = false;
						this.deviceListIsFinish = true;
						this.devicePageNum = 1;
						this.deviceTip = "数据加载失败~";
					}
				});
			},
			fanhuiFn() {
				this.zsgltdBool = false;
			},
			company_rowFn(id) {
				this.zsgltdBool = true;
				var data = {
					id: id
				}
				company_row(data).then(res => {
					if(res.result == 1) {
						this.companysrow = res.row;
						this.nameVal = this.companysrow.cName;
						this.lxtel = this.companysrow.cTel;
						this.ylImg = this.companysrow.cImgA;
						this.yyImg = this.companysrow.cImgB;
						this.vxVal = this.companysrow.cWxImg;
						this.gfwzVal = this.companysrow.cUrl;
						this.addressVal = this.companysrow.cAddr;
						//						this.zspwdVal=this.companysrow.lUserPwd;
						this.chengshiFn()
						this.sheng = this.companysrow.cProvinceID;
						this.shiFn()
						this.shi = this.companysrow.cCityID;
						this.minname = this.companysrow.cNickName
					}
				})
				var data1 = {
					cpy_id: id,
					user_type:'1,2,3,0,8',
					pageSize:100
					//					rz:2,
				}
				this.glList = [];
				this.tdlist=[];
				users_list_company(data1).then(res => {
					this.glList =  res.data;
					for(var i=0;i<this.glList.length;i++){
						this.tdlist.unshift(this.glList[i]);
						this.tdlist.sort(this.up);
						console.log(this.tdlist);
					}
				})

			},
			up(a,b){
				return a.uTypeID-b.uTypeID
			},
			city_ztreeFn(val, val1) {
				city_ztree().then(res => {
					var data = res.data;
					for(var i = 0; i < data.length; i++) {
						if(data[i].id == val) {
							var a = data[i].name
						}
					}
					for(var j = 0; j < data.length; j++) {
						if(data[j].id == val1) {
							var b = data[j].name
						}
					}
					this.csVal = a + '/' + b
				})
			},
			chengshiFn() {
				var data = {
					pid: 100000
				}
				city_ztree(data).then(res => {
					var data = res.data;
					for(var i = 0; i < data.length; i++) {
						this.sList.push(data[i]);
					}
				})
			},
			shiFn() {
				this.shiList = [];
				this.shi = '';
				var data = {
					pid: this.sheng
				}
				city_ztree(data).then(res => {
					var data = res.data;
					for(var i = 0; i < data.length; i++) {
						this.shiList.push(data[i]);
					}
				})
			},
			xianFn() {
				this.xianList = [];
				this.xian = '';
				var data = {
					pid: this.shi
				}
				city_ztree(data).then(res => {
					var data = res.data;
					for(var i = 0; i < data.length; i++) {
						this.xianList.push(data[i]);
					}
				})
			},
			jschengshiFn() {
				var data = {
					pid: 100000
				}
				city_ztree(data).then(res => {
					var data = res.data;
					for(var i = 0; i < data.length; i++) {
						this.jssList.push(data[i]);
					}
				})
			},
			jsshiFn() {
				this.jsshiList = [];
				this.shiId = '';
				if(this.shengId==''){
					
				}else{
					var data = {
						pid: this.shengId
					}
					city_ztree(data).then(res => {
						var data = res.data;
						for(var i = 0; i < data.length; i++) {
							this.jsshiList.push(data[i]);
						}
					})
				}
			},
			jsxianFn() {
				this.xianList = [];
				this.xianId = '';
				var data = {
					pid: this.shiId
				}
				city_ztree(data).then(res => {
					var data = res.data;
					for(var i = 0; i < data.length; i++) {
						this.jsxianList.push(data[i]);
					}
				})
			},
			jiansuoFn() {
				this.sousuo = true;
				this.datalist = [];
				this.deviceListnodata = true;
				this.deviceListIsLoad = false;
				this.deviceListIsFinish = true;
				this.devicePageNum = 1;
				this.getlist()
				this.sousuo = false;
			},
			xgxxFn() {
				var data = {
					id: this.companysrow.id,
					cTypeID: '1',
					cName: this.nameVal,
					cTel: this.lxtel,
					cAddr: this.addressVal,
					cProvinceID: this.sheng,
					cCityID: this.shi,
					cLatLng: '',
					cIsShowSlideSelf: '1',
					cUrl: this.gfwzVal,
					cWxImg: this.vxVal,
					cImgA: this.ylImg,
					cImgB: this.yyImg,
					cRoute: this.addressVal,
					lUserPwd: this.zspwdVal,
					cNickName: this.minname,
					cPerson:this.companysrow.cPerson
				}
				company_save(data).then(res => {
					var that = this;
					if(res.result == 1) {
						that.$message({
							message: '修改成功',
							type: 'success',
							duration: 1000,
							onClose: () => {
								this.xxgsVal = false;
							}
						})
					} else {
						that.$message({
							message: res.msg,
							type: 'error',
							duration: 1000,
							onClose: () => {}
						})
					}
				})
			},
			getSex(sex) {
				return sex == 1 ? '男' : '女';
			},
			scrollEvent(e) {
				if(e instanceof Event) {
					let el = e.target;
					let scrollTop = el.scrollTop;
					// 获取可视区的高度
					let clientHeight = el.clientHeight;
					// 获取滚动条的总高度
					let scrollHeight = el.scrollHeight;
					let height = 140; //一格表格的高
					if(scrollTop + clientHeight >= scrollHeight && this.deviceListIsLoad && !this.deviceListIsFinish) {
						this.deviceListIsLoad = true;
						//			        console.log("到底了");
						var timer = setTimeout(() => {
							this.getlist();
							clearTimeout(timer)
						}, 1000);
					}
				}
			},
			Sfqmonthdaydiv(table, event) {
				var el = event.target
				$(el).addClass('router-link-active');
				$(el).siblings().removeClass('router-link-active');
				$(el).parent().parent().siblings().children().children().removeClass('router-link-active');
				this.$router.push({
					path: '/indexDr/DrtechnologyCommunication/table4',
					query: {
						name: 1
					}
				})
			},
			yyxkImgFn(){
				if(this.companysrow.cImgA){
					this.centerDialogVisible=true;
					this.DialogImg=this.companysrow.cImgA;
				}else{
					this.$message({
		                message:"该诊所未上传营业许可证",
		                type: 'info',
		                duration:1000,
		                onClose:()=>{
		                	that.xxgsVal=false;
		                	that.xiugaiqueding=false;
		                	that.companys_rowFn();
		         		}
					})
				}
			},
			yyzzImgFn(){
				if(this.companysrow.cImgA){
					this.centerDialogVisible=true;
					this.DialogImg=this.companysrow.cImgB;
				}else{
					this.$message({
		                message:"该诊所未上传营业执照",
		                type: 'info',
		                duration:1000,
		                onClose:()=>{
		                	that.xxgsVal=false;
		                	that.xiugaiqueding=false;
		                	that.companys_rowFn();
		         		}
					})
				}
			},
			imgCloseFn() {
				this.yyzzImg = false;
				this.yyxkImg = false;
			},
			upDrtechnologyCommunication() {

			},
			hznumFn() {
				this.hznumBool = true;
			},
			hidehznumFn() {
				this.hznumBool = false;

			},
			DIYbqFn() {
				this.DIYbqBool = true;
			},
			hideDIYbqFn() {
				this.DIYbqBool = false;
			},
			taggleFn(str, event) {
				var el = event.target;
				if(this.jub(str, this.sclyArr)) {
					$(el).removeClass('active');
					this.sclyArr.splice(this.sclyArr.indexOf(str), 1)
					var data = {
						uGoods: '传统修复'
					}
					users_save(data).then(res => {
						if(res.result == 1) {
							this.$message({
								message: '提交成功',
								type: 'success',
								duration: 1000,
								onClose: () => {}
							})
						} else {
							this.$message({
								message: res.msg,
								type: 'error',
								duration: 1000,
								onClose: () => {}
							})
						}
					})
				} else {
					$(el).addClass('active')
					this.sclyArr.push(str)
					var data = {
						uGoods: '传统修复'
					}
					users_save(data).then(res => {
						if(res.result == 1) {
							this.$message({
								message: '提交成功',
								type: 'success',
								duration: 1000,
								onClose: () => {}
							})
						} else {
							this.$message({
								message: res.msg,
								type: 'error',
								duration: 1000,
								onClose: () => {}
							})
						}
					})
				}
			},
			tabClick(str, el) {
				var el = event.currentTarget;
				$(el).addClass('active').siblings().removeClass('active')
				if(str == '1') {
					this.mzglBool = true;
					this.cyglBool = false;
				} else if(str == '2') {
					this.cyglBool = true;
					this.mzglBool = false;
					this.xxgsVal = false
				}
			},
			jub(num, arr) {
				for(var i = 0; i < arr.length; i++) {
					if(num == arr[i]) {
						return true;
					}
				}
			},
			yqgrFn() {
				var data = {
					cpy_id:this.companysrow.id,
					tel: this.tel
				}
				get_company(data).then(res => {
					if(res.result == 1) {
						this.$message({
							message: res.msg,
							type: 'success',
							duration: 1000,
							onClose: () => {
								this.addCyBool=false;
							}
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'info',
							duration: 1000,
							onClose: () => {
								this.addCyBool=false;
							}
						})
					}
				})
			},
			handleAvatarSuccess(res, file) {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.2)'
				});
				let that = this;
				var reader = new FileReader();
				console.log(file)
				reader.readAsDataURL(file.raw);
				var img = new Image;
				var a = 0;
				var name = file.name;
				reader.onload = function() {
					let base64Str = reader.result.split(',')[1];
	                img.src = this.result;
					this.dataobj = {
						img_str: img.src,
						dir: 'upload/file',
						file_name: name

					}
					imgbase64upload(this.dataobj).then(res => {
						if(res.result == 1) {
							var image1 = res.img;
							that.$message({
								message: '上传成功',
								type: 'success',
								duration: 1000,
								onClose: () => {
									loading.close();
									that.ylImg = image1;
								}
							})
						} else {
							that.$message({
								message: '图片加载失败',
								type: 'error',
								duration: 1000,
								onClose: () => {
									loading.close();
									that.BATSimageBannercenter = '';
								}
							})
						}
					})
				};
				reader.onerror = function(error) {
					loading.close();
				};
			},
			 beforeAvatarUpload(file){
	    	 	if (!/^image\/(jpeg|png)$/.test(file.type)) {
			          this.$confirm('上传图片暂时只支持PNG/JPG格式', '提示', {
			            confirmButtonText: '确定',
			            type: 'error' ,
			            callback: action => {
			
			            }
			          })
			    }
//			      return isJPG;
			},
			handleAvatarSuccess1(res, file) {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.2)'
				});
				let that = this;
				var reader = new FileReader();
				reader.readAsDataURL(file.raw);
				var img = new Image;
				var a = 0;
				var name = file.name
				reader.onload = function() {
					let base64Str = reader.result.split(',')[1];
	                img.src = this.result;
					this.dataobj = {
						img_str: img.src,
						dir: 'upload/file',
						file_name: name
					}
					imgbase64upload(this.dataobj).then(res => {
						if(res.result == 1) {
							var image1 = res.img;
							that.$message({
								message: '上传成功',
								type: 'success',
								duration: 1000,
								onClose: () => {
									loading.close();
									that.yyImg = image1;
								}
							})
						} else {
							that.$message({
								message: '图片加载失败',
								type: 'error',
								duration: 1000,
								onClose: () => {
									loading.close();
									that.BATSimageBannercenter = '';
								}
							})
						}
					})
				};
				reader.onerror = function(error) {
					loading.close();
				};
			},
			checkActiveFn(event, tel, id) {
				var el = event.currentTarget;
				if($(el).children('.check').is('.active')) {
					$(el).children('.check').removeClass('active');
					var data = {
						uid: id,
						zt: 0,
						cpyid:this.companysrow.id
					}
					set_dual_status_new(data).then(res => {})
				} else {
					$(el).children('.check').addClass('active');
					var data = {
						uid: id,
						zt: 1,
						cpyid:this.companysrow.id
					}
					set_dual_status_new(data).then(res => {})
				}
			},
			checkActiveFnDpc(event, tel, id){
				var el = event.currentTarget;
				if($(el).children('.check').is('.active')) {
					$(el).children('.check').removeClass('active');
					var data = {
						id: id,
						uIsAccDpc: 0
					}
					user_save(data).then(res => {})
				} else {
					$(el).children('.check').addClass('active');
					var data = {
						id: id,
						uIsAccDpc: 1
					}
					user_save(data).then(res => {})
				}
			},
			checkActiveFnPdm(event, tel, id){
				var el = event.currentTarget;
				if($(el).children('.check').is('.active')) {
					$(el).children('.check').removeClass('active');
					var data = {
						id: id,
						uIsAccPdm: 0
					}
					user_save(data).then(res => {})
				} else {
					$(el).children('.check').addClass('active');
					var data = {
						id: id,
						uIsAccPdm: 1
					}
					user_save(data).then(res => {})
				}
			},
			checkActiveFnCep(event, tel, id){
				var el = event.currentTarget;
				if($(el).children('.check').is('.active')) {
					$(el).children('.check').removeClass('active');
					var data = {
						id: id,
						uIsAccCep: 0
					}
					user_save(data).then(res => {})
				} else {
					$(el).children('.check').addClass('active');
					var data = {
						id: id,
						uIsAccCep: 1
					}
					user_save(data).then(res => {})
				}
			},
		},
		watch: {
			$route(to, from) {
				if(this.$route.query.hide == 1) {
					$('.communicationPt').hide();
				}
			}
		},
	}
</script>

<style scoped>
	.box {
		width: 100%;
		height: 100%;
		position: relative;
	}
	
	.communication {
		font-size: 12px;
		width: 100%;
		float: right;
		height: 788px;
		position: relative;
		/*cursor: pointer;*/
		overflow: hidden;
		background: #FFFFFF;
	}
	
	.communicationPt {
		font-size: 12px;
		width: 100%;
		float: right;
		height: 788px;
		position: relative;
		cursor: pointer;
		overflow: hidden;
		/*background: #FFFFFF;*/
	}
	
	.communicationPt {
		z-index: 998;
		position: absolute;
	}
	
	.Atlist {
		width: 302px;
		height: 100%;
	}
	
	.Attable {
		margin-left: 302px;
		height: 100%;
		/*background: #7797B2;*/
	}
	
	.commtitle {
		height: 70px;
		width: 100%;
		line-height: 70px;
		font-weight: 600;
		font-size: 18px;
		color: #9B9B9B;
		border-bottom: 2px solid rgba(119, 151, 178, 0.16);
	}
	
	.iconImg {
		display: block;
		width: 22px;
		height: 22px;
		float: left;
		margin-top: 25px;
		margin-right: 11px;
		margin-left: 20px;
		color: #9B9B9B;
	}
	
	.c1 {
		background: url(../../../assets/image/c1.png) no-repeat center center;
	}
	
	.addNewAt {
		width: 302px;
		height: 40px;
		background: rgba(104, 107, 117, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		text-align: center;
		line-height: 40px;
		font-size: 14px;
		color: #FFFFFF;
	}
	
	.Atlistxiangqing {}
	
	.Attableheader {
		height: 70px;
		border-bottom: 2px solid rgba(119, 151, 178, 0.16);
		;
	}
	
	.retrievalipt {
		margin-top: 15px;
		width: 263px;
		margin-left: 20px;
		padding-bottom: 20px;
		border-bottom: 2px solid #F1F1F1;
	}
	
	.datard {
		margin-top: 5px;
		overflow: hidden;
	}
	
	.datard span {
		display: block;
		float: left;
	}
	
	.datard>span:nth-child(1) {
		margin-right: 5px !important;
		width: 93px !important;
	}
	
	.datard>span:nth-child(2),
	.datard>span:nth-child(3) {
		width: 72px;
		margin-right: 5px;
	}
	
	.Attablelist {
		height: 100%;
		background: #F5F5F5;
	}
	
	.Attablelistbox {
		width: 257px;
		height: 266px;
		padding-top: 14px;
		float: left;
		/*margin-right: 3px;*/
		border-right: 3px solid #CCCCCC;
		/*background:rgba(155,155,155,1);*/
		/*box-shadow:0px 0px 2px 0px rgba(119,151,178,0.16);*/
	}
	
	.qhtable {
		width: 48px;
		height: 48px;
		background: rgba(0, 120, 255, 1);
		border-radius: 50%;
		position: absolute;
		bottom: 45px;
		right: 30px;
	}
	
	.jgghzlist {
		height: 789px;
	}
	
	.tablehzlist {
		/*width: 776px;*/
		height: 789px;
	}
	
	.retrievalspan {
		/*margin-top:10px ;*/
		overflow: hidden;
	}
	
	.zdyspan {
		/*border-left:1px !important;*/
		border: 1px solid rgba(215, 215, 215, 1) !important;
	}
	
	.zdyspan .el-icon-edit-outline {
		color: #0073FF;
	}
	
	.retrievalspan span {
		display: block;
		margin-top: 10px;
		height: 20px;
		padding-left: 10px;
		padding-right: 10px;
		margin-right: 10px;
		/*margin-bottom: 5px;*/
		line-height: 20px;
		color: rgba(155, 155, 155, 1);
		background: rgba(255, 255, 255, 1);
		border: 1px solid rgba(215, 215, 215, 1);
		border-left: 5px solid #636670;
		border-radius: 3px;
		text-align: left;
		float: left;
		cursor: pointer;
	}
	
	.retrievalspan span.active {
		font-weight: 600;
		color: rgba(0, 120, 255, 1);
		border-left-color: rgba(0, 120, 255, 1);
	}
	
	.dq>div>p {
		padding-bottom: 5px;
		padding-left: 5px;
	}
	
	.selectDiv,
	.selectDiv1 {
		/*margin-right: 6px;*/
		margin-bottom: 10px;
	}
	
	.selectDiv1 {
		margin-left: 6px;
	}
	
	.selectDiv>div {
		width: 113px;
		float: left;
		margin-right: 5px;
	}
	
	.selectDiv1>div {
		width: 123px;
		float: left;
		margin-right: 5px;
	}
	
	.selectDiv>span>p {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		line-height: 20px;
	}
	
	.selectDiv1>span>p {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		line-height: 40px;
	}
	
	.dqBox {
		margin-top: 20px;
		margin-left: 20px;
		overflow: hidden;
	}
	
	.dqBox>p {
		font-size: 16px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(0, 0, 0, 1);
		line-height: 22px;
		margin-bottom: 5px;
	}
	
	.dqBox>div.boxbtn {
		width: 263px;
		height: 40px;
	}
	
	.dqBox>div.boxbtn:hover button {
		border: 2px solid yellow;
	}
	
	.dqBox>div.boxbtn>button {
		width: 263px;
		height: 40px;
		background: rgba(0, 120, 255, 1);
		color: #FFFFFF;
		font-size: 16px;
	}
	/*。。。。。。。。。。。。。*/
	
	.tableHeader {
		margin-top: 40px;
		width: 100%;
		height: 30px;
		border-bottom: 2px solid rgba(119, 151, 178, 0.16);
		;
	}
	
	.tablecontent {
		margin-top: 0;
		width: 100%;
		height: 140px;
		border-bottom: 3px solid #FFFFFF;
		position: relative;
		background: #F5F5F5;
	}
	
	.tablecontent::before {
		content: "";
		display: block;
		position: absolute;
		top: 11px;
		left: 0;
		width: 100%;
		height: 50px;
		z-index: 2;
		background: #FFFFFF;
	}
	
	.tablecontent::after {
		content: "";
		display: block;
		position: absolute;
		bottom: 11px;
		left: 0;
		width: 100%;
		height: 50px;
		z-index: 2;
		background: #FFFFFF;
	}
	
	.tableHeader li {
		height: 30px;
	}
	
	.tableHeader li,
	.tablecontent li {
		float: left;
		text-align: center;
		font-size: 12px;
		color: #9B9B9B;
	}
	
	.tablecontent li {
		height: 140px;
		line-height: 140px;
		position: relative;
		color: #9B9B9B;
		z-index: 3;
		overflow: hidden;
	}
	
	.tablecontent li::before {
		content: "";
		display: block;
		position: absolute;
		top: 11px;
		left: 0;
		width: 2px;
		height: 118px;
		border-left: 2px dashed #D7D9DC;
		/*px*/
	}
	
	.tablecontent li:nth-child(1)::before {
		border: none;
	}
	
	.tablecontent li:nth-child(1) {
		display: flex;
		justify-content: center;
		align-items: center;
		line-height: 20px;
	}
	
	.tablecontent li:nth-child(1)>p {
		margin: 0 10px;
		word-wrap: break-word;
		word-break: break-all
	}
	
	.tablecontent li:nth-child(2)::before {}
	
	.tableHeader li:nth-child(1) {
		width: 15%;
	}
	
	.tableHeader li:nth-child(2) {
		width: 14%;
	}
	
	.tableHeader li:nth-child(3) {
		width: 10%;
	}
	
	.tableHeader li:nth-child(4) {
		width: 15%;
	}
	
	.tablecontent li:nth-child(4) {
		display: flex;
		justify-content: center;
		align-items: center;
		line-height: 20px;
	}
	
	.tablecontent li:nth-child(4)>p {
		margin: 0 10px;
		word-wrap: break-word;
		word-break: break-all
	}
	
	.tableHeader li:nth-child(5) {
		width: 13%;
	}
	
	.tableHeader li:nth-child(6) {
		width:33%;
		display: flex;
		justify-content: center;
	}
	
	.tableHeader li:nth-child(6)>div:nth-child(1) {
		width: 120px;
		height: 30px;
		margin: 54px auto;		
	}
	
	.tableHeader li:nth-child(6)>div:nth-child(1):hover button {
		border: 2px solid yellow;
	}
	
	.tableHeader li:nth-child(6)>div:nth-child(1)>button {
		width: 120px;
		height: 30px;
		background: rgba(0, 120, 255, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 11px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		line-height: 16px;
		float: left;
	}
	
	.tableHeader li:nth-child(6)>div:nth-child(2) {
		width: 80px;
		height: 30px;
		margin: 54px auto;		
	}
	
	.tableHeader li:nth-child(6)>div:nth-child(2):hover button {
		border: 2px solid yellow;
	}
	
	.tableHeader li:nth-child(6)>div:nth-child(2)>button {
		width: 80px;
		height: 30px;
		background: #F56C6C;
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 11px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		line-height: 16px;
		float: left;
	}
	.tabletd {
		/*position: absolute;
		top: 30px;
		left: 0;*/
		overflow: auto;
		background: #F5F5F5;
		width: 100%;
		height: 721px;
	}
	
	.gjretrieval>div {
		margin: 20px 0;
		overflow: hidden;
		line-height: 20px;
		font-size: 14px;
		font-family: PingFangSC-Regular;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		cursor: pointer;
	}
	
	.gjretrieval>div>div:nth-child(2)>span:nth-child(1) {}
	
	.gjretrieval>div>span:nth-child(2) {
		margin-right: 30px;
	}
	
	.gjretrieval>div>span>i {
		display: block;
		width: 20px;
		height: 20px;
		border-radius: 50%;
		background: url(../../../assets/image/圈未选中.png) no-repeat center center;
		background-size: 100%;
		float: left;
		margin-right: 10px;
	}
	
	.gjretrieval>div>span>i.active {
		background: url(../../../assets/image/选中.png) no-repeat center center;
		background-size: 100%;
	}
	
	.gjretrieval>p>i {
		margin-left: 14px;
		font-weight: 600;
		transition: .3S all;
	}
	
	.gjretrieval>p>i.active {
		transition: .3S all;
		transform: rotateZ(90deg);
	}
	
	.gjretrieval div>span:nth-child(1) {
		font-size: 14px;
		margin-right: 10px;
		font-family: PingFangSC-Regular;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
	}
	
	.list-more {
		width: 100%;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}
	
	.notJoined {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.notJoined>div {
		width: 299px;
		height: 274px;
		padding: 0 40px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.13);
		border-radius: 8px;
		margin-top: -100px;
	}
	
	.notJoined>div>div:nth-child(2) {
		font-size: 14px;
		font-family: PingFangSC;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		line-height: 20px;
		margin-bottom: 60px;
		margin-top: 90px;
	}
	
	.notJoined>div:nth-child(1)>div:nth-child(3)>button {
		width: 299px;
		height: 35px;
		background: rgba(176, 176, 176, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 11px;
		font-family: PingFangSC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		line-height: 16px;
	}
	
	.notJoined>div:nth-child(2)>div:nth-child(3)>button {
		width: 299px;
		height: 35px;
		background: rgba(0, 120, 255, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 11px;
		font-family: PingFangSC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		line-height: 16px;
	}
	
	.myJoined,
	.joinedComposition {
		width: 100%;
		height: 789px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 2px 2px 2px 0px rgba(119, 151, 178, 0.16);
	}
	
	.header {
		width: 100%;
		height: 68px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 2px 0px rgba(119, 151, 178, 0.16);
		z-index: 90;
		position: relative;
	}
	
	.header>div:nth-child(1) {
		width: 255px;
		height: 100%;
		float: left;
		position: absolute;
	}
	
	.header>div:nth-child(1)>i {
		font-size: 18px;
		margin-left: 23px;
		margin-right: 10px;
	}
	
	.header>div:nth-child(1)>span:nth-child(2) {
		font-size: 18px;
		font-family: PingFangSC;
		font-weight: 500;
		color: rgba(155, 155, 155, 1);
		line-height: 68px;
	}
	
	.header>div:nth-child(1)>span:nth-child(3) {
		font-size: 18px;
		font-family: PingFangSC;
		font-weight: 500;
		color: rgba(74, 74, 74, 1);
		line-height: 68px;
	}
	
	.header>div:nth-child(2) {
		margin-left: 130px;
		height: 100%;
	}
	
	.header>div:nth-child(2)>div:nth-child(1) {
		width: 100%;
	}
	
	.content {
		width: 100%;
		height: 719px;
		background: RGBA(245, 245, 245, 1);
		/*overflow: hidden;*/
		/*padding-left: 5px;*/
		/*display: flex;
		justify-content:space-around;*/
		/*align-items: center;*/
		/*box-shadow:0px 0px 2px 0px rgba(119,151,178,0.16);*/
	}
	
	.joinedList>div {
		width: 216px;
		height: 118px;
		background: rgba(255, 255, 255, .7);
		border-radius: 3px;
		font-size: 14px;
		font-family: PingFangSC;
		font-weight: 500;
		color: rgba(74, 74, 74, 1);
		text-align: center;
		line-height: 118px;
		margin: 10px 0;
	}
	
	.content>div.fl {
		width: 130px;
		height: 720px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 2px 0px 4px 0px rgba(155, 155, 155, 0.23);
	}
	
	.navMenuTd {
		width: 130px;
		height: 50px;
		background: rgba(246, 246, 246, 1);
		box-shadow: 0px 2px 4px 0px rgba(155, 155, 155, 0.4);
		border-radius: 0px 0px 15px 0px;
		cursor: pointer;
		line-height: 50px;
		position: relative;
		margin-bottom: 5px;
	}
	
	.navMenuTd>span {
		font-size: 14px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 600;
		color: rgba(74, 74, 74, 1);
		margin-left: 15px;
	}
	
	.navMenuTd>i {
		font-size: 15px;
		color: #9B9B9B;
		font-weight: bold;
		position: absolute;
		right: 13px;
		top: 19px;
		transition: .3s all;
	}
	
	.navMenuTd:hover {
		background: #FFFFFF;
	}
	
	.navMenuTd:hover span {
		color: #3B97FF;
	}
	
	.navMenuTd.active {
		background: #FFFFFF;
	}
	
	.navMenuTd.active>span {
		color: #3B97FF;
	}
	
	.navMenuTd.active>i {
		transform: rotate(90deg);
		transition: .3s all;
	}
	
	.content>div:nth-child(2) {
		/*width: calc(100%-205px);*/
		/*width: 76%;*/
		/*margin-top: 2px;*/
		margin-left: 130px;
		/*box-shadow:0px 0px 4px 0px rgba(0,0,0,0.13);*/
		/*float: left;*/
		/*margin-left: ;*/
	}
	
	.modelcontent {
		width: 100%;
		height: 718px;
		background: #F5F5F5;
	}
	
	.modelcontent>div:nth-child(1) {
		width: 100%;
		height: 142px;
	}
	
	.modelcontent>div:nth-child(2) {
		width: 100%;
		height: 575px;
	}
	
	.modelcontent>div:nth-child(1)>div:nth-child(1) {
		width: 100%;
		border-right: none;
	}
	
	.modelcontent>div>div:nth-child(2) {
		/*width: calc(100%-75px);*/
		/*margin-left: 75px;*/
	}
	
	.modelcontent>div:nth-child(1)>div:nth-child(1) {
		border-bottom: 3px solid #FFFFFF;
		height: 139px;
	}
	
	.userSet {
		width: 100%;
		height: 142px;
		border-bottom: 3px solid #FFFFFF;
		overflow: hidden;
	}
	
	.userSet>div {
		width: 100%;
		height: 117px;
		background: #FFFFFF;
		margin-top: 14px;
	}
	
	.userSet>div>div:nth-child(1)>div {
		margin-top: 41px;
		margin-right: 15px;
		overflow: hidden;
	}
	
	.userSet>div>div:nth-child(2)>div {
		margin-right: 69px;
		margin-top: 18px;
		margin-bottom: 13px;
	}
	
	.userSet>div>div:nth-child(2)>div>button {}
	
	.userSet>div>div:nth-child(1)>div:nth-child(1) {
		margin-left: 83px;
	}
	
	.userSet>div>div>div {
		width: 100px;
		height: 30px;
	}
	
	.userSet>div>div>div:hover button {
		border: 2px solid #F8E71C;
	}
	
	.userSet>div>div>div>button {
		width: 100px;
		height: 30px;
		background: rgba(0, 120, 255, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 11px;
		font-family: PingFangSC-Medium, PingFangSC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
	}
	
	.modelcontent>div>div:nth-child(1)>p {
		font-size: 16px;
		font-family: PingFangSC-Medium;
		font-weight: 600;
		width: 32px;
		line-height: 20px;
		color: rgba(74, 74, 74, 1);
		margin-top: 3px;
	}
	
	.modelcontent>div:nth-child(1)>div:nth-child(2) {
		border-bottom: 3px solid #FFFFFF;
		height: 139px;
		/*width: 90.5%;*/
		/*width: 100%;*/
		margin-left: 75px;
	}
	
	.modelcontent>div:nth-child(2)>div:nth-child(2) {
		height: 575px;
	}
	
	.tdlist{
		height: 100%;
		overflow-y:scroll ;
	}
	.tdlist>div{
		display: flex;
		min-height:142px;
	}
	.tdlist>div:nth-child(2){
		/*margin-left: 63px;*/
	}
	.tdlist>div>div:nth-child(1){
		width:60px;
		height: auto;
		border-right: 3px solid #FFFFFF;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.tdlist>div>div{
		width: 100%;
		border-bottom: 3px solid #FFFFFF;
		overflow: hidden;
		text-align: center;
	}
	.tdlist>div>div>p{
		font-size:12px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(155,155,155,1);
		line-height:23px;
	}
	.zl>p:nth-child(1){
		writing-mode: tb-rl;
	}
	
	.tablelist {
		position: relative;
		height: 142px;
		width: 100%;
		/*overflow: hidden;*/
	}
	
	.tableList {
		position: relative;
		height: 100%;
		overflow: hidden;
	}
	
	.tableList>li {
		/*height: 100%;*/
		float: left;
		text-align: center;
		margin-top: 50px;
		color: rgba(155, 155, 155, 1);
		font-size: 11px;
		font-family: PingFangSC;
		font-weight: 600;
	}
	
	.tablelist>li {
		height: 142px;
		float: left;
		text-align: center;
		position: relative;
		font-size: 11px;
		font-family: PingFangSC;
		font-weight: 600;
		color: rgba(155, 155, 155, 1);
		z-index: 3;
	}
	
	.tablelist>li:nth-child(2) {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.tablelist>li:nth-child(2)>p {
		line-height: 20px;
		margin: 0 10px;
		word-wrap: break-word;
		font-weight: 600;
		word-break: break-all
	}
	
	.tablelist>li:nth-child(3) {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.tablelist>li:nth-child(3)>p {
		line-height: 20px;
		margin: 0 10px;
		word-wrap: break-word;
		font-weight: 600;
		word-break: break-all
	}
	
	.tablelist>li:nth-child(6) {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.tablelist>li:nth-child(6)>p {
		line-height: 20px;
		margin: 0 10px;
		word-wrap: break-word;
		font-weight: 600;
		word-break: break-all
	}
	
	.tablelist>li:nth-child(7) {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.tablelist>li:nth-child(7)>p {
		line-height: 20px;
		margin: 0 10px;
		word-wrap: break-word;
		font-weight: 600;
		word-break: break-all
	}
	
	.tablelist::before {
		content: "";
		display: block;
		position: absolute;
		top: 11px;
		left: 0;
		width: 100%;
		height: 50px;
		z-index: 2;
		background: rgba(255, 255, 255, 1);
	}
	
	.tablelist::after {
		content: "";
		display: block;
		position: absolute;
		bottom: 11px;
		left: 0;
		width: 100%;
		height: 50px;
		z-index: 2;
		background: rgba(255, 255, 255, 1);
	}
	
	.tablelist>li:before {
		content: "";
		display: block;
		width: 2px;
		height: 117px;
		position: absolute;
		top: 12px;
		right: 0;
		border-right: 2px dashed rgba(215, 217, 220, 1);
	}
	
	.tablelist>li:nth-child(1) {
		width: 10%;
		line-height: 142px;
	}
	
	.tablelist>li:nth-child(2) {
		width: 9%;
		line-height: 142px;
	}
	
	.tablelist>li:nth-child(3) {
		width: 15%;
		overflow: hidden;
	}
	
	.tablelist>li:nth-child(4) {
		width: 11%;
		line-height: 142px;
	}
	
	.tablelist>li:nth-child(5) {
		padding-top: 45px;
		width: 12%;
		height: 92px;
		position: relative;
		text-align: left;
	}
	
	.tablelist>li:nth-child(5)>p {
		cursor: pointer;
		font-size: 11px;
		font-family: PingFangSC;
		font-weight: 600;
		color: rgba(155, 155, 155, 1);
		line-height: 25px;
		margin-left: 20px;
	}
	
	.tablelist>li:nth-child(5)>p>i {
		color: rgba(0, 120, 255, 1);
		margin-right: 5px;
	}
	
	.dialogImg {
		width: 177px;
		height: 130px;
		position: absolute;
		top: 100px;
		left: -100px;
		z-index: 9999;
		border: 1px solid #CCCCCC;
		border-radius: 5px;
	}
	
	.dialogImg>img {
		width: 177px;
		height: 130px;
	}
	
	.dialogImg>i {
		display: block;
		width: 20px;
		height: 20px;
		cursor: pointer;
		font-size: 20px;
		color: #000000;
		position: absolute;
		right: 10px;
		top: 10px;
	}
	
	.tablelist>li:nth-child(6) {
		width: 13%;
		overflow: hidden;
	}
	
	.tablelist>li:nth-child(7) {
		width: 9%;
	}
	
	.tablelist>li:nth-child(8) {
		width: 17%;
		/*line-height: 142px;*/
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.tablelist>li:nth-child(8)>div {
		width: 100px;
		height: 30px;
		margin: 0 auto;
	}
	
	.tablelist>li:nth-child(8)>div:hover button {
		border: 2px solid yellow;
	}
	
	.tablelist>li:nth-child(8)>div>button {
		float: left;
		width: 100px;
		height: 30px;
		background: rgba(0, 120, 255, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 11px;
		font-family: PingFangSC-Medium, PingFangSC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
	}
	
	.tablelist>li:nth-child(8):before {
		display: none;
	}
	
	.tableList>li:nth-child(1) {
		width: 10%;
	}
	
	.tableList>li:nth-child(2) {
		width: 9%;
	}
	
	.tableList>li:nth-child(3) {
		width: 15%;
	}
	
	.tableList>li:nth-child(4) {
		width: 11%;
	}
	
	.tableList>li:nth-child(5) {
		width: 12%;
	}
	
	.tableList>li:nth-child(6) {
		width: 13%;
	}
	
	.tableList>li:nth-child(7) {
		width: 9%;
	}
	
	.tableList>li:nth-child(8) {
		width: 17%;
	}
	
	.dialogAddopple {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, .3);
		z-index: 99;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.dialogAddopple>div {
		width: 312px;
		height: 268px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 4px 0px 12px 0px rgba(0, 0, 0, 0.13);
		border-radius: 10px;
		padding: 30px 30px;
	}
	
	.dialogAddopple>div>div:nth-child(1)>p:nth-child(2) {
		font-size: 18px;
		font-family: PingFangSC;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		line-height: 25px;
	}
	
	.dialogAddopple>div>div:nth-child(1)>p:nth-child(1) {
		font-size: 20px;
		margin-bottom: 15px;
		font-weight: bold;
		overflow: hidden;
	}
	
	.addHeader {
		padding-bottom: 12px;
		border-bottom: 2px solid rgba(241, 241, 241, 1);
	}
	
	.addCenter>p {
		font-size: 14px;
		font-family: PingFangSC;
		font-weight: 400;
		color: rgba(34, 34, 34, 1);
		margin-top: 20px;
		margin-bottom: 5px;
	}
	
	.addCenter>div>input {
		width: 292px;
		height: 20px;
		padding: 10px;
		background: rgba(255, 255, 255, 1);
		border-radius: 8px;
		outline: none;
		font-size: 14px;
		font-family: PingFangSC;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		border: 1px solid rgba(221, 227, 232, 1);
		margin-bottom: 15px;
	}
	
	.addFooter {
		margin-top: 30px;
	}
	
	.addFooter>div {
		width: 311px;
		height: 40px;
	}
	
	.addFooter>div:hover button {
		border: 2px solid #F8E71C;
	}
	
	.addFooter>div>button {
		width: 311px;
		height: 40px;
		background: rgba(0, 120, 255, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 14px;
		font-family: PingFangSC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
	}
	
	.dpcPdm {
		position: absolute;
		right: 5px;
		bottom: 5px;
	}
	
	.dpcPdm>p {
		line-height: 16px;
		overflow: hidden;
		margin-bottom: 10px;
	}
	
	.dpcPdm>p>i {
		float: left;
	}
	
	.tdcyBox {
		width: 217px;
		height: 118px;
		padding: 12px 0;
		float: left;
		margin-right: 2px;
		overflow: hidden;
	}
	
	.tdcyBox>div {
		width: 217px;
		height: 118px;
		background: rgba(255, 255, 255, 1);
		border-radius: 3px;
		position: relative;
		border-right: 2px dashed rgba(215, 217, 220, 1);
	}
	
	.tdcyBox>div::before {
		content: "";
		display: block;
		height: 100%;
		width: 2px;
		position: absolute;
		top: 0;
		right: 0;
		/*border-right:2px dashed rgba(215, 217, 220, 1) ;*/
	}
	
	.tdcyBox>div>div {
		float: left;
	}
	
	.tdcyBox>div>div:nth-child(1) {
		padding: 10px;
		height: 98px;
		width: 74px;
	}
	
	.tdcyBox>div>div:nth-child(1)>img {
		height: 98px;
		width: 74px;
	}
	
	.tdcyBox>div>div:nth-child(2) {
		padding: 10px 5px;
	}
	
	.tdcyBox>div>div:nth-child(2)>p:nth-child(1) {
		font-size: 14px;
		font-family: PingFangSC-Semibold, PingFangSC;
		font-weight: 600;
		color: rgba(74, 74, 74, 1);
		margin: 12px 0;
	}
	
	.tdcyBox>div>div:nth-child(2)>p:nth-child(2) {
		margin-bottom: 5px;
		line-height: 15px;
	}
	
	.tdcyBox>div>div:nth-child(2)>p:nth-child(2)>i {
		float: left;
		margin-right: 5px;
	}
	
	.tdcyBox>div>div:nth-child(2)>span {
		display: block;
		width: 59px;
		height: 20px;
		background: rgba(255, 255, 255, 1);
		text-align: center;
		line-height: 20px;
		border-radius: 3px;
		border: 1px solid rgba(215, 215, 215, 1);
	}
	
	.tdcyBox>div>div:nth-child(2)>span:nth-child(3) {
		border-left: 3px solid #D4B54F;
	}
	
	.tdcyBox>div>div:nth-child(2)>span:nth-child(4) {
		border-left: 3px solid #1DB5FF;
	}
	
	.tdcyBox>div>div:nth-child(2)>span:nth-child(5) {
		border-left: 3px solid #636670;
	}
	
	.tdcyBox>div>div:nth-child(2)>.el-icon-delete-solid,
	.tdcyBox>div>div:nth-child(2)>.el-icon-refresh-right {
		font-size: 20px;
		position: absolute;
		top: 10px;
		right: 10px;
		color: red;
		cursor: pointer;
		opacity: .5;
	}
	
	.tdcyBox>div>div:nth-child(2)>.el-icon-refresh-right {
		display: none;
	}
	
	.tdcyBox>div>div:nth-child(2)>.el-icon-delete-solid:hover,
	.tdcyBox>div>div:nth-child(2)>.el-icon-refresh-right:hover {
		opacity: 1;
	}
	
	.check {
		display: block;
		width: 15px;
		height: 15px;
		border-radius: 50%;
		background: url(../../../assets/image/圈未选中.png) no-repeat center center;
		background-size: 100%;
	}
	
	.check.active {
		background: url(../../../assets/image/选中.png) no-repeat center center;
		background-size: 100%;
	}
	
	.zsxxFrom {}
	
	.zsxxFrom>div:nth-child(1) {
		padding: 0 105px 0 70px;
		/*width:1075px;*/
		height: 60px;
		line-height: 60px;
		border-bottom: 2px solid #FFFFFF;
	}
	
	.zsxxFrom>div:nth-child(1)>div {
		float: right;
		width: 126px;
		height: 30px;
		margin-right: 20px;
	}
	
	.zsxxFrom>div:nth-child(1)>div:hover button {
		border: 2px solid #F8E71C;
	}
	
	.zsxxFrom>div:nth-child(1)>div>button {
		width: 126px;
		height: 30px;
		background: rgba(0, 120, 255, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 11px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		line-height: 16px;
		margin-top: 16px;
		cursor: pointer;
		margin-right: 10px;
	}
	
	.zsxxFrom>div>span {
		font-size: 16px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: rgba(74, 74, 74, 1);
		line-height: 23px;
	}
	
	.zsxxFrom>div:nth-child(2) {
		margin-top: 18px;
		width: 100%;
		height: 619px;
		background: rgba(255, 255, 255, .7);
		border-radius: 3px;
	}
	
	.zsxxFrom>div:nth-child(2)>div:nth-child(2) {
		float: left;
		height: 619px;
		width: 50%;
	}
	
	.fromIpt {
		height: 619px;
		width: 50%;
		float: left;
	}
	
	.fromIpt>div {
		/*width: 50%;*/
		height: 509px;
		border-right: 1px dashed rgba(215, 217, 220, 1);
		border-left: 1px solid RGBA(245, 245, 245, 1);
		padding: 55px 70px;
	}
	
	.fromIpt1>div {
		/*width: 50%;*/
		height: 509px;
		padding: 55px 70px;
	}
	
	.fromIpt>div {}
	
	.comClass>p>i,
	.comClass1>p>i,
	.comClass2>p>i {
		display: block;
		background: url(../../../assets/image/选中.png) no-repeat center center;
		background-size: 100%;
		width: 15px;
		height: 15px;
		float: left;
		margin-right: 5px;
		margin-top: 4px;
	}
	
	.comClass>p,
	.comClass1>p,
	.comClass2>p {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(34, 34, 34, 1);
		line-height: 23px;
		margin-bottom: 5px;
	}
	
	.comClass,
	.comClass1 {
		margin-bottom: 20px;
	}
	
	.selectDiv,
	.selectDiv1 {
		margin-right: 10px;
		margin-bottom: 10px;
	}
	
	.selectDiv>span>p {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		line-height: 20px;
	}
	
	.selectDiv1>span>p {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		line-height: 40px;
	}
	
	.blockDiv>div {
		width: 263px !important;
	}
	
	.blockDiv>div>.el-date-editor.el-input__inner {
		width: 263px !important;
	}
	
	.avatar-uploader {
		width: 177px;
		height: 130px;
		background: rgba(121, 139, 149, 0.44);
		box-shadow: 0px 0px 4px 0px rgba(155, 155, 155, 0.23);
		border-radius: 2px;
		text-align: center;
	}
	
	.avatar-uploader .el-icon-picture {
		font-size: 34px;
		color: #FFFFFF;
		line-height: 124px;
	}
	
	.el-upload img {
		width: 177px;
		height: 130px;
	}
	
	.comClass2 {
		margin-top: 50px;
	}
	
	.comClass2>div>div:nth-child(1) {
		margin-right: 17px;
		margin-bottom: 15px;
	}
	
	.comClass2>div>div>span {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(34, 34, 34, 1);
		line-height: 23px;
	}
	.gjjiansuo{
		/*margin-left:27px ;*/
		/*display: none;*/
		overflow: hidden;
		margin-left: 25px;
		margin-top: 25px;
		margin-bottom: 30px;
	}
	.gjjiansuo>span{
		font-size:13px;
		font-weight:500 !important;
		color:rgba(215,215,215,1);
		margin-right: 16px;
		cursor: pointer;
		border-bottom: 1px solid #D7D7D7;
	}
	.gjjiansuo>span.active{
		color: rgba(0,120,255,1);
		border-bottom: 1px solid rgba(0,120,255,1);
	}
	.gjjiansuo>span:hover{
		color: rgba(0,120,255,1);
		border-bottom: 1px solid rgba(0,120,255,1);
	}
</style>
<style type="text/css">
	.el-dialog--center .el-dialog__body{
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/components/MA/clinicManagement/clinicManagement.vue